import jwt from '@/auth/jwt/useJwt'
import { computed, ref } from '@vue/composition-api'
import Vue from 'vue'

export default function Events() {
  const route = 'events'
  const event = ref({
    organization_id: Vue.prototype.$orgId,
    address: {},
    category: '',
    sub_category: '',
    venue: { address: {} },
    organizer: { },
    is_published: true,
    language: 'English (United States)',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    start_date: '',
    main_image: {},
    start_time: '',
    end_time: '',
    location_type: 'offline',
    currency: {},
    video_url: '',
    is_start_time_displayed: true,
    is_end_time_displayed: true,
  })

  const formattedEvent = computed(() => ({
    organizer_id: event.value.organizer.id,
    event_type_id: event.value.type?.id,
    category_id: event.value.category?.id,
    sub_category_id: event.value.sub_category?.id,
    currency_id: event.value.currency?.id,
    ...(event.value.location_type === 'offline' ? { venue: event.value.venue } : {}),
    location_type: event.value.location_type,
    organization_id: event.value.organization_id,
    title: event.value.title,
    video_url: event.value.video_url,
    main_image: event.value.main_image?.id,
    images: event.value.images?.map(image => image.id),
    description: event.value.description,
    createdTags: event.value.tags?.filter(tag => !tag.id).map(tag => tag.name),
    tags: event.value.tags?.map(tag => tag.id).filter(tag => tag),
    summary: event.value.summary,
    ...(event.value.location_type === 'online' ? { location_online: event.value.location_online } : {}),
    start_date: event.value.start_date,
    start_time: event.value.start_time,
    end_date: event.value.end_date,
    end_time: event.value.end_time,
    is_start_time_displayed: event.value.is_start_time_displayed,
    is_end_time_displayed: event.value.is_end_time_displayed,
    timezone: event.value.timezone,
    language: event.value.language,
    is_published: 1,
  }))

  const getEventsRequest = params => jwt.axiosIns.get(route, { params }).then(res => res).catch(() => [])

  const getAttendeesRequest = (id, params) => jwt.axiosIns.get(`/event/${id}/booking/attendees`, { params }).then(res => res).catch(() => [])

  const exportAttendeesRequest = (id, params) => jwt.axiosIns.get(`/event/${id}/booking/attendees/export`, { params, responseType: 'blob' }).then(res => res).catch(() => [])

  const getEventRequest = (id, params = { embed: 'currency,subCategory,tickets' }) => jwt.axiosIns.get(`${route}/${id}`, { params }).then(res => res).catch(() => [])

  const addEventRequest = () => jwt.axiosIns.post(route, formattedEvent.value).then(res => res)

  const updateEventRequest = () => jwt.axiosIns.put(`${route}/${event.value.id}`, formattedEvent.value).then(res => res)

  const changeStatusRequest = (eventId, statusId) => jwt.axiosIns.post(`${route}/${eventId}/change-status`, { status: statusId }).then(res => res)

  const publishEventRequest = id => jwt.axiosIns.post(`${route}/${id}/publish`).then(res => res)

  const unpublishEventRequest = id => jwt.axiosIns.post(`${route}/${id}/un-publish`).then(res => res)

  const deleteEventRequest = id => jwt.axiosIns.delete(`${route}/${id}`).then(res => res)

  return {
    event, getEventsRequest, getEventRequest, addEventRequest, updateEventRequest, changeStatusRequest, publishEventRequest, unpublishEventRequest, deleteEventRequest, getAttendeesRequest, exportAttendeesRequest,
  }
}
